import ReactDOM from "react-dom";
import React from "react";
import SearchFacets from "../components/search/SearchFacets";

const init = () => {
  let mountPoint = document.querySelector("#SearchFacets");

  if (mountPoint) {
    ReactDOM.render(
      <SearchFacets facets={mountPoint.getAttribute("data-facets")} />,
      mountPoint
    );
  }
};

// Init on initial page load
init();

